/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
    BehaviorSubject,
    catchError,
    map,
    Observable,
    of,
    ReplaySubject,
    switchMap,
    take,
    tap,
    throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { Talla } from './talla.types';
import { User } from '../user/user.types';

@Injectable({
    providedIn: 'root',
})
export class TallaService {
    private urlApiAuth: string = environment.BASE_URL;
    private _Talla: BehaviorSubject<Talla > = new BehaviorSubject<Talla>(null);
    private _Tallas: BehaviorSubject<Talla[] > = new BehaviorSubject<Talla[]>(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Getter for Talla
     */
    get Talla$(): Observable<Talla> {
        return this._Talla.asObservable();
    }

    /**
     * Getter for Tallas
     */
    get Tallas$(): Observable<Talla[]> {
        return this._Tallas.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Get Talla by id
     */
    obtenerDatosUsuario(idUserClient: number): Observable<User> {
        return this._httpClient.get<User>(`${this.urlApiAuth}citas/reactive/usuario/${idUserClient}`)
        .pipe(
            catchError(this.handleError)
        );
    }
    private handleError(error: HttpErrorResponse) {
        let errorMessage = 'Unknown error!';
        if (error.error instanceof ErrorEvent) {
          // Client-side errors
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // Server-side errors
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        return throwError(errorMessage);
      }

    getTallas(): Observable<Talla[]>
    {
        // Si ya tenemos datos en el BehaviorSubject, retornarlos sin hacer nueva petición
        const currentTallas = this._Tallas.getValue();
        if (currentTallas && currentTallas.length > 0) {
            return of(currentTallas);
        }

        // Si no tenemos datos, hacer la petición HTTP
        return this._httpClient.get<Talla[]>(this.urlApiAuth + 'citas/reactive/tallas' ).pipe(
            switchMap((Tallas: Talla[]) =>
            {
                this._Tallas.next(Tallas);
                return of(Tallas);
            }),
            catchError((error: any) => {
              return of([]);
            }));
    }

    getTallaById(id: string): Observable<Talla> {
        return this._httpClient.get<Talla>(this.urlApiAuth + '/' + id).pipe(
            take(1),
            switchMap((Talla: Talla) => {
                if (!Talla) {
                    return throwError(
                        'Could not found Talla with id of ' + id + '!'
                    );
                }
                this._Talla.next(Talla);
                this.updateTallaInList(Talla);
                return of(Talla);
            })
        );
    }

    updateTalla(Talla: Talla): Observable<Talla> {
        return this._httpClient.put<Talla>(this.urlApiAuth + '/', Talla).pipe(
            take(1),
            switchMap((Talla: Talla) => {
                this._Talla.next(Talla);
                this.updateTallaInList(Talla);
                return of(Talla);
            })
        );
    }
    deleteTalla(id: string): Observable<boolean> {
        return this._httpClient.delete<any>(this.urlApiAuth + id).pipe(
            take(1),
            switchMap((data: any) => {
                this.updateTallaInList(this.getTallaByIdInList(+id));
                return of(data);
            })
        );
    }
    /**
     * Create Talla
     */
    createTalla(Talla: Talla): Observable<Talla> {
        return this._httpClient.post<Talla>(this.urlApiAuth, Talla).pipe(
            take(1),
            switchMap((Talla: Talla) => {
                this._Tallas.next([Talla, ...this._Tallas.value]);
                return of(Talla);
            })
        );
    }

    /*
     *
     *Funciones auxiliares
     */

    // Función para actualizar un objeto Talla en la lista
    updateTallaInList(updatedTalla: Talla): void {
        const currentTallas = this._Tallas.getValue();

        if (currentTallas) {
          const indice = currentTallas.findIndex(group => group.id === updatedTalla.id);
          if (indice !== -1) {
            currentTallas[indice] = updatedTalla;
              this._Tallas.next([...currentTallas]); // Emite una nueva lista actualizada
          } else {
              console.log(`No se encontró ningún Talla con el ID ${updatedTalla.id}.`);
          }
      } else {
          console.log('La lista de grupos está vacía.');
      }
    }

    getTallaByIdInList(id: number): Talla | null{
        const currentTallas = this._Tallas.value;

        if (currentTallas) {
            this._Tallas.value.map((Talla: Talla) => {
                if (Talla.id === id) {
                    return Talla;
                }
            });

            return null;
        }
    }

    /**
     * Limpiar caché de tallas - útil cuando se necesite refrescar los datos
     */
    clearTallasCache(): void {
        this._Tallas.next(null);
    }

    /**
     * Forzar recarga de tallas desde el servidor
     */
    refreshTallas(): Observable<Talla[]> {
        this.clearTallasCache();
        return this.getTallas();
    }
}
